import { call, put, takeLatest } from 'redux-saga/effects';
import { Creators, Types } from '../../redux/image/actions';
import {
  uploadImage as uploadImageApi
} from '../../api/image';

export function* uploadImage(actions) {
  try {
    const { history, payload } = actions;
    const data = yield call(uploadImageApi, payload);
    yield put(Creators.uploadImageSuccess(data));
    history.push('/activate/step/six');
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.uploadImageFailure(error_message));
  }
}

export function* watchUploadImage() {
  yield takeLatest(Types.UPLOAD_IMAGE, uploadImage);
}

